import {merge} from 'lodash';
import Assessment from '../assessment';
import AssessmentResult from '../../../values/AssessmentResult';
import {META_DESCRIPTION_LENGTH_ID, META_TAG_POINTS} from '@axyseo/const/analysis';

/**
 * Assessment for calculating the length of the meta description.
 */
export default class MetaDescriptionLengthAssessment extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {Object} [config] The configuration to use.
   *
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: META_DESCRIPTION_LENGTH_ID,
      ctaType: 'fix',
      docUrl:
        'https://docs.avada.io/seo-suite-help-center/seo-on-page-audit/checklist#meta-description-length-off-target',
      priority: 'high',
      fixPosition: 'meta description',
      title: 'Meta description length',
      content: {
        good: 'Meta description is optimized, less than 160 characters.',
        improve: '',
        bad:
          'Missing meta description. Write a unique and compelling description under 160 characters.'
      }
    };

    this.identifier = META_DESCRIPTION_LENGTH_ID;
    this._config = merge(defaultConfig, config);
  }

  /**
   * Runs the metaDescriptionLength module, based on this returns an assessment result with score.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   * @param {Researcher}  researcher  The researcher used for calling research.
   *
   * @returns {AssessmentResult} The assessment result.
   */
  getResult({paper, researcher}) {
    const assessmentResult = new AssessmentResult({config: this._config});

    const calculatedResult = this.calculateResult(paper);

    assessmentResult.setScore(calculatedResult.score);
    assessmentResult.setStatus(calculatedResult.status);

    return assessmentResult;
  }

  /**
   *
   * @param paper
   * @returns {{score: number, status: string}}
   */
  calculateResult(paper) {
    const length = paper.getDescription().length;

    let status = 'bad';

    if (length === 0) {
      status = 'bad';
    }
    if (length <= 160 && length >= 50) {
      status = 'good';
    }
    const score = this.getScore(META_TAG_POINTS, status);

    return {
      score,
      status
    };
  }

  /**
   * Checks whether the paper has a text.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   *
   * @returns true
   */
  isApplicable(paper) {
    return true;
  }
}
